import { Chip } from "@mui/material";
import React from "react";

import type { AccountStatus } from "../../../types/accountIntelligence";

const STATUS_CONFIG: Record<AccountStatus, { label: string; color: string; bgColor: string }> = {
  engaged: { label: "Engaged", color: "#2e7d32", bgColor: "rgba(46,125,50,0.13)" },
  watching: { label: "Watching", color: "#1976d2", bgColor: "rgba(25,118,210,0.12)" },
  candidate: { label: "Candidate", color: "#9e9e9e", bgColor: "rgba(158,158,158,0.10)" },
  deprioritized: { label: "Deprioritized", color: "#616161", bgColor: "rgba(97,97,97,0.10)" },
};

interface AccountStateChipProps {
  state: AccountStatus;
  size?: "small" | "medium";
}

const AccountStateChip: React.FC<AccountStateChipProps> = ({ state, size = "small" }) => {
  const cfg = STATUS_CONFIG[state];
  return (
    <Chip
      label={cfg.label}
      size={size}
      sx={{
        color: cfg.color,
        backgroundColor: cfg.bgColor,
        border: `1px solid ${cfg.color}40`,
        fontWeight: 500,
        fontSize: size === "small" ? "0.7rem" : "0.8rem",
      }}
    />
  );
};

export default AccountStateChip;
